import dayjs, { Dayjs } from 'dayjs';

import { TIME_HOUR_MINUTE_SEC_FORMAT } from 'technical/time-utils/constants';
import timezoneManagement from 'technical/time-utils/dayjs.timezone';

export function parseShiftTimeString(timeString: string) {
  return dayjs.tz(
    timeString,
    TIME_HOUR_MINUTE_SEC_FORMAT,
    timezoneManagement.getDefaultTz(),
  );
}

export function parseShiftTimeStringWithReportDate(
  shiftTimeString: string,
  reportDate: Dayjs,
) {
  const shiftTimeNotOnDate = parseShiftTimeString(shiftTimeString);
  const shiftHour = shiftTimeNotOnDate.hour();
  const shiftMinute = shiftTimeNotOnDate.minute();

  return reportDate.hour(shiftHour).minute(shiftMinute);
}
